import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { companyActions } from '../../../redux/actions/company-action';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import {
  Grid,
  Row,
  Col,
  Tooltip,
  OverlayTrigger
} from "react-bootstrap";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import BackNavigationButton from "components/ThemeComponents/BackNavigationButton";
import { savePagination, getSavedPagination } from '../../../helper/helperFunctions';
const queryString = require('query-string');

class CompanyUsersAllListPage extends React.Component {
	constructor(props){
		super(props);
        const { savedPage, savedPageSize } = getSavedPagination("companyUsers");
        const parsed = queryString.parse(window.location.search);
        this.state = {
            sorted   :'',
            filtered :'',
            savedPage: parsed.restore_page ? savedPage : 0,
            savedPageSize: parsed.restore_page ? savedPageSize : 10
        };
        this.companyPaginationData  = this.companyPaginationData.bind(this);
        this.filterSearchHandle     = this.filterSearchHandle.bind(this);
	}

  filterSearchHandle(e){
      this.setState({
          'filtered': e.target.value
      });
  }
	companyPaginationData(page, filter, sort, pageSize){
		this.props.getCompanyAllUsersCall(page, filter, sort, pageSize);
	}
	render(){
        const { companyUsersData,companyUsersPages,loading  } = this.props;
        const { filtered } = this.state;
		    const columns = [
            {
                Header:"Company Users Listing",
                columns: [
                    {
                        Header: "Name",
                        accessor: "name",
                        className: "action-center"
                    },
                    {
                        Header: "Email",
                        accessor: "email",
                        className: "action-center"
                    },
                    {
                        Header: "Phone",
                        accessor: "phone",
                        className: "action-center"
                    },
                    {
                        Header:"Company",
                        accessor: "company",
                        Cell: ({value}) => (
                          <div>
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Company</Tooltip>}>
                              <Link to={'/Admin/Edit-Company/'+value.id+'?Company/Users'} >{ value.name }</Link>
                            </OverlayTrigger>
                          </div>
                          ),
                        className: "action-center",
                        sortable:false
                    },
                    {
                        Header:"Actions",
                        accessor: "company",
                        Cell: ({value}) => (
                          <div>
                            <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Company Users List</Tooltip>}>
                              <Link to={'/Admin/Company/'+value.id+'/users'} className="action-button-size"><i className="fa fa-users " /></Link>
                            </OverlayTrigger>
                          </div>
                          ),
                        className: "action-center",
                        sortable:false,
                        show:false
                    }
                ]
            }
        ];
		return(
            <div className="content">
                <Grid fluid>
                  <Row>
                    <Col md={12}>
                      <Card
                        headerTopContent={
                          <div style={{ marginBottom: "10px" }}>
                            <BackNavigationButton
                              defaultPath="Companies"
                              queryPrefix=""
                              className="btn btn-info btn-sm"
                              title="Back"
                            />
                          </div>
                        }
                        title="Companies Users List"
                        ctTableResponsive
                        content={
                          <div>
                            <Grid fluid>
                                <Row>
                                    <Col md={8}>
                                    </Col>
                                    <Col md={4} sm={6} xs={12} >
                                      <div>
                                        <FormInputs
                                          ncols={["col-md-12"]}
                                          onChange={this.filterSearchHandle}
                                          proprieties={[
                                            {
                                              type: "text",
                                              bsClass: "form-control",
                                              placeholder: "Seach Company Users",
                                              onChange:this.filterSearchHandle,
                                              name:"filter"
                                            }

                                          ]}
                                        />
                                      </div>
                                    </Col>
                                </Row>
                            </Grid>
                            <ReactTable
                                
                                data={companyUsersData}
                                pages={companyUsersPages} 
                                loading = {loading}
                                columns={columns}
                                filtered={filtered}
                                page={this.state.savedPage}
                                pageSize={this.state.savedPageSize}
                                className="striped hover"
                                pageData = {this.companyPaginationData}
                                manual
                                onFetchData={(state) => {
                                    savePagination("companyUsers", state.page, state.pageSize);
                                    this.setState({
                                      savedPage: state.page,
                                      savedPageSize: state.pageSize
                                    });
                                    var sort = state.sorted.length === 0 ? '' : state.sorted[0].id+',desc:'+state.sorted[0].desc;
                                    state.pageData(state.page+1, state.filtered, sort, state.pageSize);
                                }}
                            />
                          </div>
                        }
                      />
                    </Col>
                  </Row>
                </Grid>
            </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getCompanyAllUsersCall  : (page, filter, sort, pageSize) => { dispatch(companyActions.getCompanyAllUsersPagination(page, filter, sort, pageSize)) },
  });
};

function mapStateToProps(state) {
    
    const { companyUsersData,companyUsersPages,loading } = state.companyReducer;
    return {
        companyUsersData,companyUsersPages,loading
    };
}

const CompanyUsersAllList = connect(mapStateToProps, mapDispatchToProps)(CompanyUsersAllListPage);

export default CompanyUsersAllList;


// WEBPACK FOOTER //
// ./src/components/Admin/CompanyUser/CompanyUsersAllList.jsx